import { useContext, useEffect, useState } from "react"
import { MdDelete, MdDeleteOutline, MdDownload, MdEdit, MdEmail, MdQrCodeScanner, MdSearch } from "react-icons/md"
import { TbArrowBack } from "react-icons/tb"
import {  useNavigate, useParams } from "react-router-dom"
import AreYouSure from "../../Components/AreYouSure"
import Modal from "../../Components/Modal"
import Spinner from "../../Components/Spinner"
import UserContext from "../../Context/UserContext"
import { getGroupDoc, getGroupsDocWhereExhibitor, deleteGroupDoc, updateGroupDoc, getGuestDoc, addGuestToGroupDoc } from "../../Requests/firebaseFirestore"
import { utils, write } from "xlsx"
import { saveAs } from "file-saver"
import { CgDice3 } from "react-icons/cg"
import Cookies from "universal-cookie"
import { uploadGroupAttachment } from "../../Requests/firebaseStorage"

export default function GroupGuestsPage() {
  const navigate = useNavigate()
  const {role, groupId} = useParams()
  const {user, seeAs} = useContext(UserContext)
  
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  
  const [group, setGroup] = useState({})
  const [guestList, setGuestList] = useState([])
  
  const [action, setAction] = useState({})
  const [newAction, setNewAction] = useState({})
  const [toAddList, setToAddList] = useState([])

  const [sureModal, setSureModal] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [sureGuestModal, setSureGuestModal] = useState(false)
  const [giveAwayModal, setGiveAwayModal] = useState(false)
  const [actionModal, setActionModal] = useState(false)
  const [scanModal, setScanModal] = useState(false)
  
  const [newName, setNewName] =useState('')
  const [search, setSearch] = useState({})
  const [numWinners, setNumWinners] = useState(1)
  const [winners, setWinners] = useState([])
  const [guestToDelete, setGuestToDelete] = useState({})
  const [groupAddShortCut, setGroupAddShortcut] = useState('')

  useEffect(()=>{console.log(guestList)},[guestList])
  
  const handleGiveAwayModal = () => {
    setWinners([])
    setGiveAwayModal(!giveAwayModal)
  }

  const handleScanModal = () =>{
    setToAddList([])
    setScanModal(!scanModal)
  }

  const handleActionModal = () =>{
    setNewAction(action)
    setActionModal(!actionModal)
  }
  
  const handleEditModal = () =>{
    setEditModal(!editModal)
  }

  const handleEditSubmit = async (e) => {
    e.preventDefault()
    setSaving(true)
    await updateGroupDoc({id:groupId, name:newName})
    reloadGuestList()
    handleEditModal()
    setSaving(false)
  }

  const handleSureModal = async (res) => {
    if(res==='accepted'){
      await deleteGroupDoc(groupId)
      navigate(`/${role}/groups`)
    }
    setSureModal(!sureModal)
  }
  
  const handleSubmit = (e) =>{
    e.preventDefault()
    let filteredList = []
    group.guests.forEach((guest)=>{
      if(guest.name.toLowerCase().includes(search.name.toLowerCase())){
        filteredList = [...filteredList, guest]
      }
    })
    reloadGuestList(filteredList)
  }

  const reloadGuestList = async (guests) =>{
    setLoading(true)
    if(guests){
      setGuestList(guests)
    }else{
      if(groupId==='all'){
        var gsts
        var res
        if(seeAs===''){
          res = await getGroupsDocWhereExhibitor(user.uid)
          gsts = res.map(group=>group.guests).flat()
        }else{
          res = await getGroupsDocWhereExhibitor(seeAs.id)
          gsts = res.map(group=>group.guests).flat()
        }
        gsts = gsts.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.place === value.place && t.name === value.name
          )))
        setGroup(res)
        setGuestList(gsts)
      }else{
        const res = await getGroupDoc(groupId)
        if(res){
          setGroup(res)
          if(res.guests){
            setGuestList(res.guests)
          }else{
            setGuestList([])
          }
          if(res.action){
            setAction(res.action)
          }else{
            setAction({active:false})
          }
        }else{
          setGuestList([])
        }
      }
    }
    setLoading(false)
  }
  
  const handleSureGuestModal = async(res, guestEmail) => {
    if(guestEmail){
      setGuestToDelete(guestEmail)
    }
    if(res === 'accepted'){
      let guests = group.guests
      guests = guests.filter(gst=>gst.email!==guestToDelete)
      await updateGroupDoc({id:groupId,guests:[...guests]})
      reloadGuestList()
    }
    setSureGuestModal(!sureGuestModal)
  }
  const handleSearch = (e) => {
    const {name, value} = e.target
    setSearch({...search, [name]:value})
  }


  useEffect(()=>{
    reloadGuestList()
  },[])


  const handleDownload = () =>{
      let toXls = []
      guestList.forEach((gst)=>{
        toXls = [...toXls, {'Nombre completo':gst.name, 'Email':gst.email, 'Teléfono':gst.phone, "Empresa":gst.company, "Localidad":gst.location, "Cargo":gst.position, "Id Fiscal": gst.fiscalId}]
      })
  
      const ws = utils.json_to_sheet(toXls)
      const wb = {
        Sheets:{
          'data':ws
        },
        SheetNames:['data']
      }
      const eb = write(wb,{bookType:'xlsx',type:'array'})
      const data = new Blob([eb],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UFT-8'})
      saveAs(data, `ChannelTalks-Grupo-${group.name}.xlsx`)
  }

    const handleWinners = (e) => {
    e.preventDefault()
    let indexes = [];
    while(indexes.length < numWinners){
        let num = Math.floor(Math.random() * group.guests.length);
        if(indexes.indexOf(num) === -1) indexes.push(num);
    }
    let winners = []
    indexes.forEach(num=>{
      winners = [...winners, group.guests[num]]
    })
    setWinners([...winners])
  }

  const handleSubmitAction = async (e) => {
    e.preventDefault()
    setSaving(true)
    let actionUpdate = newAction
    if(newAction.file){
      let urlPath = ''
      urlPath = await uploadGroupAttachment(actionUpdate.file, groupId)
      delete actionUpdate.file
      actionUpdate = {...actionUpdate, attachment:urlPath}
    }
    await updateGroupDoc({id:groupId, action:{...actionUpdate}})
    setAction({...actionUpdate})
    setActionModal(false)
    setSaving(false)
  }

  const handleNewActionInput = (e) =>{
    const {name, value} = e.target
    setNewAction({...newAction, [name]:value})
  }

  const handleAttachmentInput = async (e) => {
    if(e.target.files[0]){
      setNewAction({...newAction, file:e.target.files[0]})
    }
  }

  const handleSetShortcut = () => {
    const cookies = new Cookies()
    if(cookies.get('groupAddShortCut')===groupId){
      cookies.remove('groupAddShortCut', {path:'/'})
      setGroupAddShortcut('')
    }else{
      cookies.set('groupAddShortCut', groupId, {path:'/'})
      setGroupAddShortcut(cookies.get('groupAddShortCut'))
    }
  }
  
  useEffect(()=>{
    const cookies = new Cookies()
    if(cookies.get('groupAddShortCut')){
      setGroupAddShortcut(cookies.get('groupAddShortCut'))
    }else{
      setGroupAddShortcut('')
    }
  },[])

  const addPeopleToGroup = async () => {
    console.log([...group.guests, ...toAddList])
    const res = await addGuestToGroupDoc(groupId, [...group.guests, ...toAddList])
    setToAddList([])
    if(res.status === 'success'){
      reloadGuestList()
      handleScanModal()
    }
  }

  const getScannedGuestId = async (url) => {
    let index = url.lastIndexOf('/')
    if(url.slice(index+1, url.length).length===20 && url.slice(index+1, url.length).indexOf('.')===-1){
      const gst = await getGuestDoc(url.slice(index+1, url.length))
      if(gst){
        let check = true
        guestList.forEach(gs=>{
          if(gs.email === gst.email){
            check = false
          }
        })
        toAddList.forEach(gs=>{
          if(gs.email === gst.email){
            check = false
          }
        })
        if(gst.event === group.event.id && check){
          const {allowShareData, company, email, fiscalId, location, name, phone, position} = gst

          setToAddList([{allowShareData, company, email, fiscalId, location, name, phone, position}, ...toAddList])
        }
      }
      document.getElementById('scanned-guest').value = ''
    }
  }

  return <div className="container mx-auto px-4">
    {loading?
    <div className="flex justify-center items-center mt-6">
      <Spinner/>
    </div>:
    <>
    <div className="flex gap-2 my-4">
      {groupId!=='all'?<>
      {role!=='staff'?
    <button className="action-btn" onClick={handleEditModal}><MdEdit size={25}/></button>
    :<></>}
    <h1 className="text-stone-600 font-semibold text-xl py-2">{group.name}</h1>
    </>:
    <h1 className="text-stone-600 font-semibold text-xl py-2">Todos los contactos</h1>
    }
    </div>
    <div className="table-holder">
    <table className="w-full table-auto  min-w-[600px]" >
      <thead>
        <tr>
          <th colSpan='100%'>
            <div className="w-full px-5 flex items-center justify-between">
              <div className="flex gap-2">
                <button className="light-button flex gap-2 " onClick={()=>{navigate(`/${role}/groups`)}}><TbArrowBack size={25}/>Volver</button>
                <button className="light-button" onClick={handleScanModal}><MdQrCodeScanner size={25}/></button>
                <button className="light-button" onClick={handleGiveAwayModal}><CgDice3 size={25}/></button>
                <form onSubmit={handleSubmit} className='flex gap-2'>
                  <input type="text" className="font-normal text-black" name="name" placeholder="Buscar por nombre" onChange={handleSearch}/>
                  <button className="light-button"><MdSearch size={25}/></button>
                </form>
                <span className="flex items-center">Resultados: {guestList?guestList.length : 0}</span>
              </div>
              <div className="flex gap-2" >
                {role!=='staff'&&groupId!=='all'&&group.type!=='meetings'?
                <button className="light-button" onClick={handleActionModal}><MdEmail size={25}/></button>
                :<></>}
                {(groupId!=='all'&&group.type!=='meetings')?
                <button className="light-button" onClick={handleSureModal}>
                  <MdDeleteOutline size={25}/>
                </button>
                :<></>}

              <button className="light-button flex gap-1" onClick={handleDownload}>
                <MdDownload size={25}/>Descargar
              </button>

              </div>
            </div>
          </th>
        </tr>
        <tr>
          <th>Acciones</th>
          <th>Nombre</th>
          <th>Email</th>
          <th>Teléfono</th>
          <th>Empresa</th>
          <th>Localidad</th>
        </tr>
      </thead>
      <tbody>
        {guestList.length===0?
        <tr>
          <td colSpan='100%'>
            <h1>No se encontraron asistentes</h1>
          </td>
        </tr>:<>
        {guestList.map((guest, index)=>{
          return <tr key={index}>
            <td>
              {role!=='staff'?
              <button className="action-button border-red-500 text-red-500 hover:text-white hover:bg-red-500 active:bg-red-700 duration-150" onClick={()=>{handleSureGuestModal('', guest.email); }}><MdDelete size={25}/></button>
              :<>-</>}
            </td>
            <td>{guest.name}</td>
            <td>{guest.email}</td>
            <td>{guest.phone}</td>
            <td>{guest.company}</td>
            <td>{guest.location}</td>
          </tr>
        })}
        </>}
      </tbody>
    </table>
    </div>
    </>
      }
      <AreYouSure isActive={sureModal} handle={handleSureModal} title='¿Eliminar grupo?'/>
      <Modal isActive={editModal} handle={handleEditModal} title='Editar nombre'>
        <form onSubmit={handleEditSubmit} className='flex flex-col gap-4 justify-center'>
          <div className="input-holder w-[75%]">
            <input type="text" id="new-name" value={newName} onChange={(e)=>{setNewName(e.target.value)}} required/>
            <label htmlFor="new-name">Nuevo nombre</label>
          </div>
          <button className="send-btn" disabled={saving}>{saving?'Guardando':'Guardar'}</button>
        </form>
      </Modal>
      <Modal isActive={giveAwayModal} handle={handleGiveAwayModal} title='Sortear asistentes'>
      <form className="flex flex-col gap-4" onSubmit={handleWinners}>
      <div className="flex w-[75%] mx-auto items-center gap-2 justify-center">
        <label htmlFor="number-of-winners">Cantidad de ganadores</label>
        <input type="number" id="number-of-winners" className="w-[100px]" min={1} max={Array.isArray(group.guests)?group.guests.length:1} value={numWinners} onChange={(e)=>{setNumWinners(e.target.value)}}/>
      </div>
      <button className="send-btn">Sortear</button>
      </form>
      {winners.length!==0?<>
      <div className="flex flex-col gap-4 w-[75%] mx-auto">
      <h1 className="text-xl font-semibold">Ganadores:</h1>
      {winners.map((winner, index)=>{return(
        <>
        <div key={index} className='flex gap-2 items-center text-xl'>
          <span>{index+1}.</span><span className="text-xl">{winner.name}, {winner.company}</span>
        </div>
        </>
      )})}
      </div>
      </>:<></>}
    </Modal>
    <Modal isActive={actionModal} handle={handleActionModal} title='Definir mensaje del grupo'>
        <div className="px-[12%] flex flex-col gap-4">
          <h1 className="text-justify">Se enviará automáticamente a los asistentes cuando los agregues al grupo</h1>
          <div className="flex items-center gap-2 mx-auto w-fit">
            <input type="checkbox" id="group-use-action" className="w-[15px] h-[15px]" checked={newAction.active || false} onChange={(e)=>{setNewAction({...action, active:e.target.checked})}}/>
            <label htmlFor="group-use-action">Usar esta función</label>
          </div>
          <form onSubmit={handleSubmitAction} className='flex flex-col gap-4 justify-center items-center' id="new-action-form">
          {newAction.active?
          <>
            <div className="input-holder w-full">
              <input type="text" name="subject" id="new-action-subject" value={newAction.subject || ''} onChange={handleNewActionInput} required/>
              <label htmlFor="new-action-subject">Asunto</label>
            </div>
            <div className="input-holder w-full">
              <textarea name="body" id="new-action-body" className="h-[100px]" value={newAction.body || ''} onChange={handleNewActionInput} required/>
              <label htmlFor="new-action-body">Cuerpo</label>
            </div>
            <div className="input-holder w-full">
              <input type="file" id="new-action-attachment" onChange={handleAttachmentInput}/>
              <label htmlFor="new-action-attachment">Archivo adjunto</label> 
              {
                action.attachment?
                <a className="hover:underline" href={action.attachment} download target='_blank'>Descargar archivo actual</a>
                :
                <></>
              }
            </div>
          </>
            :<h1 className="text-center border rounded-[10px] py-3 text-stone-400 border-stone-400 w-full px-3">Active la funcion para personalizar el mensaje</h1>}
            </form>
            <button type="submit" className="send-btn" disabled={saving} form='new-action-form'>{saving?'Guardando...':'Guardar'}</button>
        </div>
    </Modal>
    <Modal isActive={scanModal} handle={handleScanModal} title='Escanear para agregar'>
      <div className="w-full px-[12%] gap-4 flex flex-col justify-center">
        <h1>Escanear con teléfono:</h1>
        <span className="text-center block mx-auto">Los asistentes que registre con su celular serán agregados a este grupo automáticamente.</span>
        <button className="send-btn" onClick={handleSetShortcut}>{groupAddShortCut===groupId?'Desactivar':'Activar atajo'}</button>
        <h1 className="text-center">o</h1>
        <h1>Escanear con escaner:</h1>
        <div className="input-holder w-full">
          <input type="text" name="scanned-guest" id="scanned-guest" onChange={(e)=>{getScannedGuestId(e.target.value)}}/>
          <label htmlFor="scanned-guest">Asistente</label>
        </div>
        <h1 className="-my-2 font-semibold">Asistentes escaneados:</h1>
        <div className="flex flex-col">
          {
            toAddList.map((gst, index)=>{return(<div key={index}><span>{index+1} - </span>{gst.name}</div>)})
          }
        </div>
        {
          toAddList.length!==0?
          <button className="send-btn" onClick={addPeopleToGroup}>Agregar {toAddList.length} personas</button>
          :<></>
        }
      </div>
    </Modal>
    <AreYouSure isActive={sureGuestModal} handle={handleSureGuestModal} title="¿Quitar asistente?"/>
  </div>
}